import { useState, useEffect } from 'react';

// Same 640px breakpoint already used independently in GamePlanTab.jsx,
// GamePlanView.jsx and TutorialOverlay.jsx — pulled out here so new call
// sites (e.g. HomeView.jsx, which had none — see production readiness
// audit, 2026-10-20) don't duplicate it a fourth time. The three existing
// copies were left as-is rather than migrated, to keep this change scoped.
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 640);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}
